import DesktopChangesView from "../../../../content/images/desktop-changesview.png";
import ScrollToAnchor from '~/src/components/scroll-to-anchor';
import * as React from 'react';
export default {
  DesktopChangesView,
  ScrollToAnchor,
  React
};